// Codekit -->
// @codekit-prepend "global/vars.js"
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/lazy.js"
// @codekit-prepend "utilities/loadIn.js"
// @codekit-prepend "utilities/infinite-load.js"

// @codekit-prepend "components/menu.js"
// @codekit-prepend "components/bulletin.js"
// @codekit-prepend "components/homepage-menu.js"
// @codekit-prepend "components/flickity.js"
// @codekit-prepend "components/ticker.js"
// @codekit-prepend "components/image-cards.js"
// @codekit-prepend "components/email-overlay.js"
// @codekit-prepend "components/accordian.js"
// @codekit-prepend "components/flicking-slides.js"
// @codekit-prepend "components/scroll-button.js"
// @codekit-prepend "components/timeline.js"

// @codekit-prepend "components/mix-cards.js"
// @codekit-prepend "components/video-overlay.js"


// @codekit-append "global/resize.js"

// Menu
menu();

//Header
// window.addEventListener("scroll", debounce(headerReveal));

//Example function pullin
// if (typeof pageTitleCtrls != "undefined" && pageTitleCtrls != null) {
//     pageTitles();
// }

// feed image cards
if (typeof imageCards != "undefined" && imageCards != null) {
    feedImages();
}

// feed mix cards
if (typeof mixCards != "undefined" && mixCards != null) {
    feedMixCards();
}

// feed video cards
if (typeof playVideoBtns != "undefined" && playVideoBtns != null) {
    feedVideoCards();
}



// email overlay
if (typeof openEmailOverlay != "undefined" && openEmailOverlay != null) {
    emailOverlay();
}

//on ready
$(document).ready(function () {
    $body.rhLoadIn();

    if (typeof homepageMenuInner != "undefined" && homepageMenuInner != null) {
        window.addEventListener("scroll", debounce(homepageAnimation));
    }

    // $body.imagesLoaded({},function(){
	// 	$('.js-parallax-element').rhParallax();
	// });

    // $('#ajaxContainer').rhLoadIn({
    //     ajax:true
    // });

    //$body.rhLoadIn();

    // $(".parallax").rhParallax({
    //     parallaxRatio: 1.4
    // });

    //images loaded
    // $(".bgImgLoad").imagesLoaded({ background: ".bgImgLoad" }, function () {
    //     $(".bgImgLoad").animate({ opacity: "1" }, 300);
    // });

    // $(".imgLoad").imagesLoaded(function () {
    //     $(".imgLoad").animate({ opacity: "1" }, 300);
    // });
}); // end doc ready

//Being rolled into lazyload by Guy
//This pauses videos on page refresh
//Ensures no flash of white
$(window).on("beforeunload", function () {
    //console.log('PAUSE VIDEO');
    $(".vidUnload").each(function () {
        $(this).get(0).pause();
    });
});

